namespace GeniuzPOS.Inventory {
    export class IcStockApproveDtColumns {
        static columnsKey = 'Inventory.IcStockApproveDt';
    }
}
